import type { Translation } from "./en";
import { accBankCs } from "./parts/accBank";
import { accDocumentsCs } from "./parts/accDocuments";
import { accInboxCs } from "./parts/accInbox";
import { accLedgerCs } from "./parts/accLedger";
import { accOverviewCs } from "./parts/accOverview";
import { accVatContactsCs } from "./parts/accVatContacts";
import { agentTabsCs } from "./parts/agentTabs";
import { agentWorkCs } from "./parts/agentWork";
import { agentsCs } from "./parts/agents";
import { alertsCs } from "./parts/alerts";
import { analysisMessagesCs } from "./parts/analysisMessages";
import { analysisQueueCs } from "./parts/analysisQueue";
import { analysisToolsCs } from "./parts/analysisTools";
import { billingCs } from "./parts/billing";
import { customersCs } from "./parts/customers";
import { decisionsCs } from "./parts/decisions";
import { flowDiagnosisCs } from "./parts/flowDiagnosis";
import { ideasCs } from "./parts/ideas";
import { miscBCs } from "./parts/miscB";
import { multiSelectCs } from "./parts/multiSelect";
import { myCs } from "./parts/my";
import { profileCs } from "./parts/profile";
import { projNewCs } from "./parts/projNew";
import { projOverviewCs } from "./parts/projOverview";
import { projReviewCs } from "./parts/projReview";
import { projSetCs } from "./parts/projSet";
import { projTabsCs } from "./parts/projTabs";
import { projVisionCs } from "./parts/projVision";
import { relCs } from "./parts/releases";
import { reportsCs } from "./parts/reports";
import { shellCs } from "./parts/shell";
import { sugCs } from "./parts/suggestions";
import { syncCs } from "./parts/sync";
import { timeEntriesCs } from "./parts/timeEntries";
import { usersCs } from "./parts/users";
import { wiBulkCs } from "./parts/wiBulk";
import { wiDetailCs } from "./parts/wiDetail";
import { wiNewCs } from "./parts/wiNew";
import { wikiCs } from "./parts/wiki";
import { workItemDetailCs } from "./parts/workItemDetail";
import { workItemListCs } from "./parts/workItemList";

export const cs: Translation = {
  ...shellCs,
  ...workItemListCs,
  ...workItemDetailCs,
  ...accBankCs,
  ...accDocumentsCs,
  ...accInboxCs,
  ...accLedgerCs,
  ...accOverviewCs,
  ...accVatContactsCs,
  ...agentsCs,
  ...flowDiagnosisCs,
  ...agentTabsCs,
  ...agentWorkCs,
  ...alertsCs,
  ...analysisQueueCs,
  ...analysisToolsCs,
  ...multiSelectCs,
  ...analysisMessagesCs,
  ...billingCs,
  ...customersCs,
  ...myCs,
  ...decisionsCs,
  ...timeEntriesCs,
  ...projReviewCs,
  ...projOverviewCs,
  ...projNewCs,
  ...projTabsCs,
  ...projVisionCs,
  ...projSetCs,
  ...wiBulkCs,
  ...wiDetailCs,
  ...wiNewCs,
  ...relCs,
  ...wikiCs,
  ...ideasCs,
  ...sugCs,
  ...syncCs,
  ...reportsCs,
  ...profileCs,
  ...usersCs,
  ...miscBCs,
  langFormat: {
    cardTitle: "Jazyk a formát",
    cardDescription: "Jazyk a formát data a čísel se uloží k účtu a platí na všech zařízeních.",
    language: "Jazyk",
    languageCs: "Čeština",
    languageEn: "English",
    format: "Formát data a čísel",
    formatCs: "Český ({{example}})",
    formatEn: "Anglický ({{example}})",
    saveFailed: "Nastavení se nepodařilo uložit",
  },
  nav: {
    profileSettings: "Nastavení profilu",
    signOut: "Odhlásit se",
  },
  userSettings: {
    language: "Jazyk",
    format: "Formát data a čísel",
    followLanguage: "Podle jazyka",
    notSet: "Nezvolen (prohlížeč / v e-mailech česky)",
  },
};
